<template>
  <nav>
    <ul>
      <li v-for="menu in menuData" :key="menu.id">
        <router-link
          :to="menu.link"
          :class="{
            active: menu.submenus && menu.submenus.some(sub => $route.path === sub.link) || $route.path === menu.link
          }"
        >
          {{ menu.title }}
          <i v-if="menu.submenus" class="fas fa-angle-down"></i>
        </router-link>
        <ul v-if="menu.submenus" class="submenu">
          <li v-for="(submenu, i) in menu.submenus" :key="i">
            <router-link
              :to="submenu.link"
              :class="{ active: $route.path === submenu.link }"
            >
              {{ submenu.title }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'HeaderNavMenu',
  data() {
    return {
      menuData: [
        {
          id: 1,
          title: "Home",
          link: "/",
          submenus: [
            { title: 'Home One', link: '/' },
            { title: 'Home Two', link: '/home-two' },
            { title: 'Home Three', link: '/home-three' },
          ],
        },
        {
          id: 2,
          title: "About Us",
          link: "/about",
        },
        {
          id: 3,
          title: "Shop",
          link: "/shop",
          submenus: [
            { title: 'Shop Layout', link: '/shop' },
            { title: 'Shop Details', link: '/shop-details' },
          ],
        },
        {
          id: 4,
          title: "Blog",
          link: "/blog",
          submenus: [
            { title: 'Blog', link: '/blog' },
            { title: 'Blog Details', link: '/blog-details' },
          ],
        },
        {
          id: 5,
          title: "Pages",
          link: "#",
          submenus: [
            { title: 'My Account', link: '/my-account' },
            { title: 'FAQs pages', link: '/faq' },
            { title: 'Cart', link: '/cart' },
            { title: 'Wishlist', link: '/wishlist' },
            { title: 'Compare', link: '/compare' },
            { title: 'Checkout', link: '/checkout' },
            { title: 'Contact Us', link: '/contact' },
            { title: '404 Error', link: '/404' },
          ],
        },
      ],
    };
  },
  computed: {
    route() {
      return this.$route; // Access the current route
    },
  },
};
</script>

<style scoped>
/* Add styles here if needed */
</style>
